import { forIn, orderBy } from "lodash";

import type { IConfigurationGroup } from "./IConfigurationGroup";
import { ConfigurationGroupType } from "./ConfigurationGroupType";
import { FunctionalityType } from "./FunctionalityType";
import { FunctionalityTypeFunctions } from "./FunctionalityTypeFunctions";
import type { IrMap } from "./IrMap";

export class ConfigurationGroupTypeFunctions {
    public static GetConfigurationGroupTypes(): ConfigurationGroupType[] {
        const cgt: ConfigurationGroupType[] = [];
        forIn(ConfigurationGroupType, (key) => {
            if (typeof key === "number") {
                cgt.push(key as any as ConfigurationGroupType);
            }
        });
        return cgt;
    }

    public static GetConfigurationTypeDictionary(
        $translate: ng.translate.ITranslateService,
    ): IrMap<ConfigurationGroupType, string> {
        const dictionary = ConfigurationGroupTypeFunctions.GetConfigurationGroupTypes().map((cgt) => ({
            key: cgt,
            value: $translate.instant(`Enums.ConfigurationGroupType.${ConfigurationGroupType[cgt]}`),
        }));

        return orderBy(dictionary, "value");
    }

    public static configurationGroupTypeIcon(configurationGroupType: ConfigurationGroupType): string {
        switch (configurationGroupType) {
            case ConfigurationGroupType.Care:
                return FunctionalityTypeFunctions.functionalityTypeIcon(FunctionalityType.Care);
            case ConfigurationGroupType.Detection:
                return FunctionalityTypeFunctions.functionalityTypeIcon(FunctionalityType.MotionDetection);
            case ConfigurationGroupType.Monitoring:
                return FunctionalityTypeFunctions.functionalityTypeIcon(FunctionalityType.Monitoring);
            case ConfigurationGroupType.Recording:
                return FunctionalityTypeFunctions.functionalityTypeIcon(FunctionalityType.Recording);
            case ConfigurationGroupType.Reporting:
                return "file-alt";
            default:
                return "question-circle";
        }
    }

    public static sortConfigurationGroupsByType(
        groups: IConfigurationGroup[],
        $translate: ng.translate.ITranslateService,
    ) {
        return orderBy(groups, [
            ({ type }) => $translate.instant(`Enums.ConfigurationGroupType.${ConfigurationGroupType[type]}`),
            (group) =>
                $translate.instant(
                    ConfigurationGroupTypeFunctions.getConfigurationGroupDefaultTransKey(group.type),
                    group,
                    "messageformat",
                ),
        ]);
    }

    public static getConfigurationGroupDefaultTransKey(type: ConfigurationGroupType) {
        switch (type) {
            case ConfigurationGroupType.Care:
                return "Entities.Default.CareConfiguration";
            case ConfigurationGroupType.Detection:
                return "Entities.Default.DetectionConfiguration";
            case ConfigurationGroupType.Monitoring:
                return "Entities.Default.MonitoringConfiguration";
            case ConfigurationGroupType.Recording:
                return "Entities.Default.RecordingConfiguration";
            case ConfigurationGroupType.Reporting:
                return "Entities.Default.ReportingConfiguration";
            default:
                return "";
        }
    }
}
